<template>
  <div class="app-container container-fluid">
    <div class="row">
      <h5 class="col-1">
        {{ $t('action.filter') }}
      </h5>
      <div class="col-3">
        <div class="input-group mb-1">
          <div class="input-group-prepend">
            <span class="input-group-text"> Por Tipo </span>
          </div>
          <select v-model="filterType" class="custom-select" @change="onChange">
            <option value="ALL">
              Todos
            </option>
            <option value="Smartdrone">
              Smartdrone
            </option>
            <option value="Presupuesto">
              Presupuestos
            </option>
            <option value="Sancor">
              Sancor Seguros
            </option>
            <option value="Daferol">
              Daferol
            </option>
            <option value="Termalesuy">
              Termalesuy
            </option>
            <option value="AMV">
              AMV
            </option>
            <option value="Zerisur">
              Zerisur
            </option>
            <option value="PcService">
              PcService
            </option>
          </select>
        </div>
      </div>
      <div class="col-1 date-filter-title">
        <b>Filtrado por Fechas:</b>
      </div>
      <div class="col-2">
        <div class="filter-date-type">
          <label><input v-model="selectedDate.type" type="radio" value="creation"> Creación</label><br>
          <label><input v-model="selectedDate.type" type="radio" value="updated"> Modificado</label><br>
        </div>
      </div>
      <div class="col-3">
        <div class="filter-date-between">
          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text"> Desde </span>
            </div>
            <input v-model="selectedDate.from" type="date" class="form-control" placeholder="desde">
          </div>
          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text"> Hasta </span>
            </div>
            <input v-model="selectedDate.to" type="date" class="form-control" placeholder="hasta">
          </div>
        </div>
      </div>
      <div class="col-2 filter-actions">
        <button class="btn btn-primary" @click="filter">
          {{ $t('action.filter') }}
        </button>
        <br>
        <button class="btn btn-danger" @click="removeFilter">
          {{ $t('action.remove_filter') }}
        </button>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="mb-4 col-2">
        <el-button :loading="downloadLoading" type="primary" icon="el-icon-document" @click="emailThem">
          Enviar Correo
        </el-button>
      </div>
    </div>
    <el-table v-loading="listLoading" :data="list" element-loading-text="Cargando..." border fit highlight-current-row @selection-change="handleSelectionChange">
      <el-table-column type="selection" align="center" />
      <el-table-column align="center" label="Id" width="75">
        <template slot-scope="scope">
          {{ getTicketId(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="Fecha" width="95">
        <template slot-scope="scope">
          {{ formatDate(scope.row.dateCreated) }}
        </template>
      </el-table-column>
      <el-table-column label="Cliente">
        <template slot-scope="scope">
          {{ scope.row.customer.firstName }} ({{ scope.row.customer.phone }})
        </template>
      </el-table-column>
      <el-table-column label="Técnico" width="105">
        <template slot-scope="scope">
          {{ scope.row.assignedTo && scope.row.assignedTo.username }}
        </template>
      </el-table-column>
      <el-table-column label="Problema">
        <template slot-scope="scope">
          {{ scope.row.issueDescription }}
        </template>
      </el-table-column>
      <el-table-column label="Diagnóstico">
        <template slot-scope="scope">
          {{ scope.row.issueDiagnostic }}
        </template>
      </el-table-column>
      <el-table-column label="Estado" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.status2">{{scope.row.status2.name}}</span>
          <span v-else>Nuevo</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import IssueService from '@/services/issue.service';
import { getTicketId, formatDate } from '@/utils/page-utils';

export default {
    name: 'MassiveMail',
    data() {
        return {
            rawList: [],
            list: null,
            listLoading: true,
            multipleSelection: [],
            downloadLoading: false,
            filterType: 'ALL',
            selectedDate: {
                type: 'creation',
                from: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
                to: new Date().toISOString().substr(0, 10)
            },
            addtHeader: [],
            addfilterVal: []
        };
    },
    created() {
        this.fetchData();
    },
    methods: {

        getTicketId,
        formatDate,
        fetchData(filteredBy, filterDate) {
            const self = this;
            let fromDate, toDate;
            let tempDate;

            if (filterDate || !this.rawList.length) {
                this.listLoading = true;

                // sanity check duplicates
                fromDate = new Date(this.selectedDate.from).getTime();
                toDate = new Date(this.selectedDate.to).getTime();

                if (fromDate > toDate) {
                    tempDate = this.selectedDate.to;
                    this.selectedDate.to = this.selectedDate.from;
                    this.selectedDate.from = tempDate;
                }

                IssueService.getIssuesByDateCustomMailing(this.selectedDate.type, this.selectedDate.from, this.selectedDate.to).then(
                    response => {
                        self.rawList = response.data;
                        self.doFiltering(self.rawList, filteredBy);
                        self.listLoading = false;
                    },
                    error => {
                        console.log(error.response && error.response.data ||
                  error.message || error.toString());
                    }
                );
            } else {
                this.doFiltering(this.rawList, filteredBy);
            }

        },
        emailThem() {
            let triggersStr, triggerActions, type, promise;
            const list = this.multipleSelection.length ? this.multipleSelection : null;
            let promises = [];

            if (list === null) {
                alert('No seleccionaste ningún ticket.');
                return;
            }
            this.downloadLoading = true;

            list.forEach(issue => {
                if (issue.status2.last) {
                    issue.emailSubject = 'Servicio Finalizado #' + this.getTicketId(issue);
                    issue.emailBody = '<b>Servicio finalizado con éxito</b><br><p><b>Equipo: </b> ' + issue.deviceBrand + ' ' + issue.serialNo + '</p><p>' + issue.issueDiagnostic + '</p><br>';
                    if (issue.estimateDescription && issue.estimateDescription.length) {
                        issue.emailBody += '<p>Presupuesto: ' + issue.estimateDescription + '</p>';
                    }
                    type = 'customer';
                } else if (issue.status2.triggers) {
                    triggersStr = '{' + issue.status2.triggers + '}';
                    try {
                        triggerActions = JSON.parse(triggersStr);

                        issue.emailSubject = 'Servicio require su atención #' + this.getTicketId(issue);
                        issue.emailBody = '<b>Requerimos su atención, por favor comunicarse con nosotros.</b><br><p><b>Equipo: </b> ' + issue.deviceBrand + ' ' + issue.serialNo + '</p><br>';
                        if (triggerActions.sendmailCustomer) {
                            type = 'customer';
                        }
                        if (triggerActions.sendmailAssignee) {
                            type = 'asignee';
                        }

                    } catch (e) {
                        console.log(e);
                    }
                } else {
                    return;
                }
                // agregado temporalmente.
                issue.emailBody += '<p style="color:red;">Semana de carnaval cerrado por licencia anual.</p>';
                // issue.emailBody += '<br><p style="font-weight:bold;">Nos Mudamos!<br>';
                // issue.emailBody += 'Te esperamos en Gral. Flores 2830 esquina Ceibal.</p>';
                issue.emailBody += '<p style="font-weight:bold;">092062626 - 0947826651</p>';
                promise = IssueService.sendMail(issue, type);
                promises.push(promise);

                promise.then(
                    response => {},
                    error => {
                        console.log(error.response && error.response.data ||
                  error.message || error.toString());
                    });
            });
            Promise.all(promises).then(() => {
                this.downloadLoading = false;
            });

        },
        doFiltering(data, filteredBy) {
            this.list = data;

            // shouldn't be necessary
            // this.list = this.list.filter(issue => {
            //     return !issue.active;
            // });

            if (filteredBy) {
                if (filteredBy === 'Smartdrone') {
                    this.list = this.list.filter(issue => {
                        return !issue.issueType || issue.issueType === '';
                    });
                } else if (filteredBy === 'Presupuesto') {
                    this.list = this.list.filter(issue => {
                        return issue.issueType && (
                            issue.issueType.toUpperCase() === filteredBy.toUpperCase() ||
                            issue.issueType.toUpperCase() === 'P'
                        );
                    });
                } else if (filteredBy.length) {
                    this.list = this.list.filter(issue => {
                        return issue.issueType && issue.issueType.toUpperCase() === filteredBy.toUpperCase();
                    });
                }
            }
        },
        filter() {
            this.onChange(true);
        },
        removeFilter() {
            this.filterType = 'ALL';
            this.fetchData(false);
        },
        onChange(fromDate) {
            if (this.filterType === 'ALL') {
                this.fetchData(null, fromDate === true);
            } else {
                this.fetchData(this.filterType, fromDate === true);
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        }
    }
};
</script>

<style lang="scss">
.radio-label {
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  //padding: 0 12px 0 30px;
  padding-right: 10px;
  letter-spacing:-1px;
}
.el-radio.is-bordered {
    margin: 0;
}
.filter-actions {
    button {
        width: 125px;
        margin-bottom: 5px;
    }
}
.el-table .cell {
    word-break: break-word;
}
.el-loading-spinner {
    top: 100px;
}
</style>
